import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { BrandingService } from '../../../shared/service/branding.service';

@Component({
  selector: 'app-login-left-panel',
  templateUrl: './login-left-panel.component.html',
  styleUrls: ['./login-left-panel.component.scss']
})
export class LoginLeftPanelComponent implements OnInit {
  @Input() loginModel: any = {};
  @Output() submit = new EventEmitter<void>();

  mainLogo: string;
  primaryColor: string;

  constructor(public brandingService: BrandingService) {}

  ngOnInit() {
    this.mainLogo = this.brandingService.getMainLogo();
    this.primaryColor = this.brandingService.getPrimaryColor();
    this.brandingService.applyThemeVariables();
  }

  onSubmit() {
    this.submit.emit();
  }
}
